import axios from 'axios'

const branchesModule = {
    namespaced: true,
    state: {
        rosstat: [],
        fns: []
    },
    actions: {
        getBranches({ commit, rootState }) {
            
            return axios({
                baseURL: `${process.env.API_PRO}company/${rootState.card?.company?.ogrn || 0}/branches?demo=true&limit=999999${window.refresh_cache ? '&_refresh_cache=true' : ''}`,
                method: 'GET',
                headers: {
                    application: 'aCjHHZY00nODFwxmLKrKRBpXECLXCfgQkn5lXB4xcx5Y42SXKzkLgJDib2F8ZKod',
                    authorization: `Bearer ${window.apiSession}`,
                    cid: window.cid
                }
            }).then(e => {
                if(e.status === 200 && (e.data?.data?.rosstar?.length || e.data?.data?.fns?.length )) {
                    commit('setStateObject', { name: 'card.branches.rosstat', value: e.data.data.rosstat }, { root: true })
                    commit('setStateObject', { name: 'card.branches.fns', value: e.data.data.fns }, { root: true })
                }
            }).catch(err => { console.error(err.message) })
        }
    }
}

export default branchesModule